/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown>, languages: NonNullable<unknown> }} Additional_Cost_Per_MinuteInputs */

const en_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Additional Cost: $${i?.cost}/minute (${i?.languages})`)
};

const fr_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Coût supplémentaire : $${i?.cost}/minute (${i?.languages})`)
};

const de_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zusätzliche Kosten: $${i?.cost}/Minute (${i?.languages})`)
};

const it_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Costo aggiuntivo: $${i?.cost}/minuto (${i?.languages})`)
};

const ru_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Дополнительная стоимость: $${i?.cost}/минута (${i?.languages})`)
};

const es_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Costo adicional: $${i?.cost}/minuto (${i?.languages})`)
};

const zh_cn2_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`额外费用：$${i?.cost}/分钟 (${i?.languages})`)
};

const ja_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`追加料金: $${i?.cost}/分 (${i?.languages})`)
};

const hi_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अतिरिक्त लागत: $${i?.cost}/मिनट (${i?.languages})`)
};

const pt_pt2_additional_cost_per_minute = /** @type {(inputs: Additional_Cost_Per_MinuteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Custo adicional: $${i?.cost}/minuto (${i?.languages})`)
};

/**
* | output |
* | --- |
* | "Additional Cost: ${cost}/minute ({languages})" |
*
* @param {Additional_Cost_Per_MinuteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const additional_cost_per_minute = /** @type {((inputs: Additional_Cost_Per_MinuteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Additional_Cost_Per_MinuteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_additional_cost_per_minute(inputs)
	if (locale === "de") return de_additional_cost_per_minute(inputs)
	if (locale === "it") return it_additional_cost_per_minute(inputs)
	if (locale === "ru") return ru_additional_cost_per_minute(inputs)
	if (locale === "es") return es_additional_cost_per_minute(inputs)
	if (locale === "zh-CN") return zh_cn2_additional_cost_per_minute(inputs)
	if (locale === "ja") return ja_additional_cost_per_minute(inputs)
	if (locale === "hi") return hi_additional_cost_per_minute(inputs)
	if (locale === "pt-PT") return pt_pt2_additional_cost_per_minute(inputs)
	return en_additional_cost_per_minute(inputs)
});